import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent, Analytics } from 'firebase/analytics';
import { ensureInitialized, fetchAndActivate, getRemoteConfig, RemoteConfig } from 'firebase/remote-config';

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
};

let analytics: Analytics | undefined;
let remoteConfig: RemoteConfig | undefined;

if (typeof window !== 'undefined') {
  const app = initializeApp(firebaseConfig);
  analytics = getAnalytics(app);
  remoteConfig = getRemoteConfig(app);

  ensureInitialized(remoteConfig)
    .then(() => fetchAndActivate(remoteConfig));
}

export { analytics, logEvent, remoteConfig };
